var render, staticRenderFns
import script from "./ArticleBox.js?vue&type=script&lang=js&"
export * from "./ArticleBox.js?vue&type=script&lang=js&"
import style0 from "./ArticleBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports